import React from "react";
import {
  Switch,
  Route
} from "react-router-dom";
import './../../style/dashboard.css';

import Head from './common/head.js';
import Sidebar from './common/sidebar.js';
import Summary from './summary.js';
import Myprojects from './myprojects.js';
import Project from './project.js';
import Profile from './user_profile.js';
import Resetpassword from './reset_password.js';
import Serviceintroduction from './service_introduction.js';
import Servicetutorial from './service_tutorial.js';
import ProjectServiceList from './project_service_list.js';
import ProjectImageDetail from './project_image_detail.js';
import ProjectImageResult from './project_image_result.js';
import ProjectImageCreate from './project_image_create.js';

import SubjectFies from './uncategorized/subject_files.js';
import ArchiveFies from './archive_files.js';

import ListData from './manager/list_data.js';
import ListUser from './manager/list_user.js';

import CreateReportT1 from './t1/create_report.js';
import CreateTestReportT1 from './t1/test_report.js';

import ListReportT1 from './t1/list_report.js';
import TestListReportT1 from './t1/test_list_report.js';

import ListSubjects from './uncategorized/list_subjects.js';
import ListService from './uncategorized/list_service.js';
import UploadSubject from './uncategorized/upload_subject.js';

import ListPrototype from './prototype/list_prototype.js';
import ListTags from './prototype/list_tags.js';

import Declaration from './../site/sign/declaration.js';
import Browsers from './../site/browsers.js';
import DocumentSeries from './../site/document_series.js';


import ConfigSite from './manager/config_site.js';
import thirdparty from './../../utils/thirdparty.js';

class Console extends React.Component {
  constructor(props) {
    super(props);
    //console.log(props);
    //console.log(localStorage);
    let user = {};
    if (typeof localStorage.token === 'undefined' || localStorage.token === '') {
      props.history.replace('/');
      return;
    } else {
      user = JSON.parse(localStorage.user);

    }

    this.state = {
      user: user
    };
  }



  onUnload(e) {
    thirdparty.getCompany();
    if (typeof localStorage.token === 'undefined' || localStorage.token === '') {
      this.props.history.replace('/');
      return;
    }
  }

  componentWillReceiveProps(nextProps) {

  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onUnload);

  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload)
  }

  render() {

    return (
      <div>
        <Head parent={this.props} />
        <div className="container-fluid">
          <div className="row">
            <Sidebar />
            <main role="main" className="col-10 ml-sm-auto px-3">

              <Switch>
                <Route path={this.props.match.path} exact component={Summary} />
                <Route path={`/console/myprojects`} exact component={Myprojects} />
                <Route path={`/console/myprojects/project/:projectid/:type`} exact component={Project} />
                <Route path={`/console/user/user_profile`} exact component={Profile} />
                <Route path={`/console/user/reset_password`} exact component={Resetpassword} />
                <Route path={`/console/service_introduction`} exact component={Serviceintroduction} />
                <Route path={`/console/service_tutorial`} exact component={Servicetutorial} />
                <Route path={`/console/myprojects/project/service_list/:projectid/:type`} exact component={ProjectServiceList} />
                <Route path={`/console/myprojects/project/service_detail/:projectid/:taskid/:type/:result`} exact component={ProjectImageDetail} />
                <Route path={`/console/myprojects/project/service_result/:projectid/:taskid/:type/:result`} exact component={ProjectImageResult} />
                <Route path={`/console/myprojects/project/service_create/:projectid/:type`} exact component={ProjectImageCreate} />

                <Route path={`/console/subject_files/:projectid/:subjectid/:data_type`} exact component={SubjectFies} />
                <Route path={`/console/archive_files/:projectid/:subjectid/:data_type`} exact component={ArchiveFies} />

                <Route path={`/console/list_subjects/:data_type/:offset`} exact component={ListSubjects} />
                <Route path={`/console/list_service/:projectid/:type`} exact component={ListService} />
                <Route path={`/console/upload_subject/:projectid/:groupid/:subjectid`} exact component={UploadSubject} />
                <Route path={`/console/list_prototype`} exact component={ListPrototype} />
                <Route path={`/console/list_tags`} exact component={ListTags} />


                <Route path={`/console/t1/create_report/:projectid/:taskid/:tid`} exact component={CreateReportT1} />
                <Route path={`/console/t1/list_report/:projectid/:taskid/:tid`} exact component={ListReportT1} />

                <Route path={`/console/t1/test_report/:projectid/:taskid/:tid`} exact component={CreateTestReportT1} />
                <Route path={`/console/t1/test_list_report/:projectid/:taskid/:tid`} exact component={TestListReportT1} />

                <Route path={`/console/manager/list_data`} exact component={ListData} />
                <Route path={`/console/manager/list_user`} exact component={ListUser} />
                <Route path={`/console/manager/config_site`} exact component={ConfigSite} />

                <Route path={`/console/declaration`} exact component={Declaration} />
                <Route path={`/console/browsers`} exact component={Browsers} />
                <Route path={`/console/document_series`} exact component={DocumentSeries} />



              </Switch>
            </main>
          </div>
        </div>

      </div>
    );
  }
}

export default Console


// WEBPACK FOOTER //
// ./src/apps/console/console.js